(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const variants = JSON.parse(root.querySelector('[data-purchase-variants]').textContent);
    const form = root.querySelector('form');
    const variantInput = root.querySelector('[data-variant-id]');
    const pickers = [...root.querySelectorAll('[data-option-index]')];
    const quantity = form.elements.quantity;
    const button = root.querySelector('[data-add-to-cart]');
    const image = root.querySelector('.product-purchase__image');
    const defaultImage = image ? {src:image.src, srcset:image.srcset, alt:image.alt} : null;
    function render(variant, updateUrl = true) {
      variantInput.disabled = !variant;
      variantInput.value = variant?.id ?? '';
      const available = Boolean(variant?.available);
      button.disabled = !available;
      button.textContent = variant ? (available ? 'Add to cart' : 'Sold out') : 'Unavailable';
      root.querySelector('[data-availability]').textContent = variant ? (available ? 'Available' : 'Sold out') : 'This combination is unavailable';
      root.querySelector('[data-price]').textContent = variant?.price ?? '';
      const compare = root.querySelector('[data-compare-price]');
      compare.hidden = !variant?.comparePrice;
      compare.textContent = variant?.comparePrice ?? '';
      const rule = variant?.quantity;
      quantity.min = rule?.min || 1;
      quantity.step = rule?.increment || 1;
      if (rule?.max) quantity.max = rule.max; else quantity.removeAttribute('max');
      let value = Math.max(Number(quantity.min), Number(quantity.value) || Number(quantity.min));
      value = Number(quantity.min) + Math.ceil((value - Number(quantity.min)) / Number(quantity.step)) * Number(quantity.step);
      if (quantity.max) value = Math.min(value, Number(quantity.max));
      quantity.value = value;
      if (image) {
        if (variant?.image) { image.removeAttribute('srcset'); image.src = variant.image; image.alt = variant.imageAlt; }
        else { image.src=defaultImage.src; image.srcset=defaultImage.srcset; image.alt=defaultImage.alt; }
      }
      root.dispatchEvent(new CustomEvent('product:variant-media', {detail:{mediaId:variant?.mediaId}}));
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state,'',url);
      }
    }
    const selectVariant = (variant, updateUrl) => {
      if (variant) pickers.forEach((picker,index) => { picker.value = variant.options[index]; });
      render(variant, updateUrl);
    };
    pickers.forEach(picker => picker.addEventListener('change', () => {
      const values = pickers.map(input => input.value);
      render(variants.find(variant => variant.options.every((value,index) => value === values[index])));
    }));
    variantInput.addEventListener('change', () => selectVariant(variants.find(variant => String(variant.id) === variantInput.value),true));
    root.querySelectorAll('[data-quantity-step]').forEach(control => control.addEventListener('click', () => {
      if (Number(control.dataset.quantityStep) > 0) quantity.stepUp(); else quantity.stepDown();
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || variantInput.disabled || form.getAttribute('aria-busy') === 'true') return;
      form.setAttribute('aria-busy', 'true');
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Could not add to cart');
        }
        button.textContent = 'Added';
        setTimeout(() => {
          button.textContent = originalText;
          form.removeAttribute('aria-busy');
        }, 1200);

        if (window.CartDrawer) {
          await window.CartDrawer.openAndRefresh();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh-and-open'));
        }
      } catch (err) {
        console.error('Add to cart failed:', err);
        button.textContent = originalText;
        form.removeAttribute('aria-busy');
        alert(err.message || 'Could not add product to cart');
      }
    });
    const resetBusy = () => form.removeAttribute('aria-busy');
    const popstate = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      selectVariant(variants.find(variant => String(variant.id) === id) || variants.find(variant => variant.available) || variants[0],false);
    };
    window.addEventListener('pageshow',resetBusy);
    window.addEventListener('popstate',popstate);
    root.purchaseCleanup = () => { window.removeEventListener('pageshow',resetBusy); window.removeEventListener('popstate',popstate); };
    if (pickers.length) {
      root.querySelector('[data-native-variants]').hidden = true;
      root.querySelector('[data-option-pickers]').hidden = false;
    }
    selectVariant(variants.find(variant => String(variant.id) === variantInput.value),false);
  }
  document.querySelectorAll('[data-product-purchase]').forEach(initialize);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-product-purchase]').forEach(initialize));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-product-purchase]').forEach(root => root.purchaseCleanup?.()));
})();
